<template>
  <div id="stashboard" class="stashboard-wrapper" :class="{loading: loading}">
    <div v-if="error" class="error">{{ error }}</div>
    <div v-if="loading" class="loading">
      <img :src="loadingGif" alt="loading"/>
    </div>
    <template v-else>
      <div class="row">
        <div class="title">
          {{ merchantNameDecoded }}
        </div>
        <div v-if="stashboardHeaders && stashboardHeaders.length > 0" class="logo">
          <template v-for="(stashboardHeader, index) in stashboardHeaders">
            <a :href="stashboardHeader.url" target="_blank">
              <img class="header-icon" :src="`${stashboardHeader.image_url}?h=48&w=48`" alt="logo"/>
            </a>
          </template>
        </div>
      </div>
      <template v-if="isContentEmpty">
        <div class="flex flex-col w-full h-full justify-center items-center text-center">
          <span class="no-content">no content available</span>
        </div>
      </template>
      <div v-else class="content">
        <Carousel
          v-if="mungedSlides.length > 0"
          :slides="mungedSlides"
          :key='mungedSlides.length'
          @playVideo="playVideo"
          @setVideoHeight="setVideoHeight"
          @pauseVideo="pauseVideo"
          @onUserInteraction="onUserInteraction"
          class="w-full"
          :class="{grab: isPreview}"
          ref="carousel"
        >
          <template #swiper-slide-content="{ slide, index }">
            <!-- X/Y counter -->
            <div v-if="mungedSlides.length > 1" class="counter">{{index + 1}}/{{mungedSlides.length}}</div>
            <!-- image container -->
            <div class="ads" v-if="slide.isImg">
              <img class="w-full object-cover h-96"
                   @click="openInNewTab(slide)"
                   :src="slide.src"
                   :alt="slide.src">
            </div>
            <!-- video container -->
            <div v-if="slide.isVideo">
              <VideoPlayer allowFullscreen
                          v-if="!slide.isYT"
                          @onVideoEnded="onVideoEnded"
                          :uniqID="`video_${index}`"
                          :ref="`video-player_${index}`"
                          :src="slide.src"/>
              <!-- YT iframe -->
              <template v-if="slide.isYT">
                <div class="z-10 absolute inset-x-0 h-2/5 top-0 transparent"></div>
                <div class="z-10 absolute inset-y-0 w-2/5 right-0 bottom-14 transparent"></div>
                <div class="z-10 absolute inset-x-0 h-1/4 bottom-12 transparent"></div>
                <div class="z-10 absolute inset-y-0 w-2/5 left-0 bottom-14 transparent"></div>
                <youtube style="height: 360px" :video-id="getIDfromYTLink(slide.src)" ref="youtube" @ended="onVideoEnded" class="w-full"/>
              </template>
            </div>

          </template>
        </Carousel>
        <div class="body">
          <div class="formatted-content" v-html="formattedContent"></div>
          <template v-if="extensionType === 'any_link'">
            <div class="anylinks">
              <a v-if="anyLinks.length > 1" @click="seeButton = !seeButton" class="see-button">
                <template v-if="seeButton">see less</template>
                <template v-else>see all</template>
              </a>
              <div class="links-wrapper" v-dragscroll.x="isPreview" :class="{ inline: !seeButton && anyLinks.length > 1}">
                <div class="links" :class="{grab: isPreview}">
                  <a :href="link.url" target="_blank" class="link" :class="{'not-clickable': isPreview}" v-for="(link, index) in anyLinks" :key="index">
                    <div class="link-icon" :class="{'link-static-size': isPreview}">
                      <svg viewBox="0 0 512.092 512.092">
                        <use xlink:href="#link-icon"></use>
                      </svg>
                    </div>
                    <div :alt="link.title" class="link-img"
                         :style="{ backgroundImage: `url(${link.thumbnail ? cleanThumbnailUrl(link.thumbnail.url) : defaultThumbnailImage })` }"/>
                    <div class="link-detail" :class="{'adapted-height': isPreview}">
                      <span class="link-title">{{ link.title }}</span>
                      <span class="link-url">{{ link.url }}</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <a v-if="labelButton" :href="urlButton ? urlButton : merchantWebsiteUrl" class="link-button" :class="{'not-clickable': isPreview}" target="_self">{{
                labelButton
              }}</a>
          </template>
          <div class="links-wrapper">
            <div v-if="appStoreUrl" class="app-store-div">
              <a :href="appStoreUrl" target="_blank">
                <img :src="appStoreImage" alt="image" class="app-store-img"/>
              </a>
            </div>
            <div v-if="googlePlayUrl" class="app-store-div">
              <a :href="googlePlayUrl" target="_blank">
                <img :src="playStoreImage" alt="image" class="app-store-img"/>
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import linkifyHtml from 'linkifyjs/html'
import { dragscroll } from "vue-dragscroll";
import loadingGif from 'passcode/loading.gif'
import defaultThumbnailImage from 'stashboard/default_thumbnail_image.png';
import appStoreImage from 'stashboard/download-on-the-app-store.png';
import playStoreImage from 'stashboard/get-it-on-google-play.png';
import Carousel from "./Carousel.vue";
import VideoPlayer from '../../components/shared/video-player'


export default {
  props: {
    anyLinks: Array,
    id: String,
    content: String,
    extensionType: String,
    merchantName: String,
    merchantWebsiteUrl: String,
    urlButton: String,
    urlImage: String,
    stashboardHeaders: Array,
    stashboardMedia: Array,
    appStoreUrl: String,
    googlePlayUrl: String,
    isPreview: Boolean,
  },
  components: {
    Carousel,
    VideoPlayer
  },
  name: "Stashboard",

  data() {
    return {
      defaultThumbnailImage,
      loading: false,
      loadingGif,
      error: null,
      seeButton: false,
      appStoreImage,
      playStoreImage,
      videoToggle: false,
      beenUserInteraction: false
    }
  },
  created() {
    /* BEGIN */
    /* This is a temporary solution for old campaign */
    /* Old campaign that does not have sms_content or extensions */
    /* This code will be removed later on */
    if (!this.extensionType & !this.content & !!this.urlButton) {
      this.loading = true
      location.replace(this.urlButton)
    }
    /* END */
    if (!this.merchantName) {
      this.loading = true
      location.replace(`/passcode/${this.id}`)
    }
  },
  computed: {
    mungedSlides() {
      return this.prepareSlides(this.stashboardMedia)      
    },

    formattedContent() {
      const options = {
          nl2br: true
        }

      return (this.content) ? linkifyHtml(this.content, options) : ""
    },

    labelButton() {
      const type = this.extensionType
      let label = ""

      if (type == "target_wallet") label = "view wallet"
      else if (!type && this.merchantWebsiteUrl) label = "shop online"
      else if (!!type) label = "view offer"

      return label
    },

    merchantNameDecoded() {
      if (this.isPreview) {
        return this.merchantName
      }
      return this.merchantName ? atob(this.merchantName) : ""
    },

    swiper() {
      return this.$refs.swiper?.$el?.swiper || null
    },
    isContentEmpty() {
      return this.isPreview &&
             this.mungedSlides.length == 0 &&
             !this.content &&
             this.anyLinks.length == 0 &&
             !this.extensionType
    },
  },
  methods: {
    playVideo(swiper, video) {
      if (!video.isYT) {
        this.$refs[`video-player_${swiper.snapIndex}`]?.playVideo()
      }

      if (video.isYT) {
        const player = this.$refs.youtube.player
        if (!this.beenUserInteraction) player.mute()
        player.playVideo()
      }
    },
    setVideoHeight(swiper, video) {
        if (!video.isYT) {
          const el = document.getElementById(`video_${swiper.snapIndex}`)
          el.onloadeddata = function() {
            document.querySelector('.stashboard-carousel .swiper-wrapper').style['height'] = `${el.clientHeight}px`
          };
        }
    },
    pauseVideo(swiper, video) {
      if (!video.isYT) this.$refs[`video-player_${swiper.previousIndex}`]?.pauseVideo()
      if (video.isYT) {
        const player = this.$refs.youtube.player
        player.pauseVideo()
      }
    },
    onUserInteraction() {
      this.beenUserInteraction = true
    },
    onVideoEnded() {
      this.$refs.youtube?.player?.stopVideo()
      // If user swiped here manually -> we don't wanna continue auto-swipe
      if (!this.beenUserInteraction) this.$refs.carousel.videoEnded()
    },
    openInNewTab(slide) {
      window.open(slide.src, '_blank')
    },
    prepareSlides(data = []) {
      return data.map((sm, index) => {
        return {
          src: sm.result_url,
          index: index,
          isVideo: sm.media_type == 'video',
          isImg: sm.media_type == 'image',
          isYT: !!sm.url
        }
      })
    },
    getIDfromYTLink(url){
      const regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/;
      const match = url.match(regExp);
      return (match&&match[1].length==11)? match[1] : false;
    },
    cleanThumbnailUrl(url) {
      if(url.startsWith("http")) {
        return `${url}?h=100&w=150`;
      }
      return url;
    },
  },
  directives: {
    dragscroll
  }
}
</script>

<style lang="scss" scoped>
.stashboard-wrapper {
  .swiper-button-prev,
  .swiper-button-next {
    @media (max-width: 768px) {
      display: none;
    }
  }

  .controls {
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: opacity .5s linear;
  }
}

.counter {
  position: absolute;
  top: 3px;
  right: 5px;
  background-color: rgba(0,0,0, 0.5);
  color: white;
  border-radius: 15px;
  padding: 2px 8px;
  z-index: 1;
}

.image-fit {
  object-fit: contain;
}

.header-icon {
  height: 48px;
  width: 48px;
}

.no-content {
  margin-top: 150px;
  width: 40%;
  font-size: 3rem;
  line-height: 3.5rem;
}

.grab {
  cursor: grab;
}

.grab:active {
  cursor: grabbing;
}

.not-clickable {
  pointer-events: none;
}

.link-static-size {
  width: 32px !important;
  height: 32px !important;
}

.adapted-height {
  height: 100px !important;
}
</style>
